module.exports = __webpack_public_path__ + "img/app_mian.5580d0f8.jpg";